import React from "react";
import styled from "styled-components";
import { Spin } from "antd";
import { CarouselMainContainer, StyledCarousel } from "../../PreMatchFoundItem/styles";
import PreMatchFoundItemCard from "../../PreMatchFoundItem/PreMatchFoundItemCard";
import { PreMatchStyledTable, StyledTableWrapper } from "../styles";
import { StyledCollapse, StyledPanel, StyledMinusIcon, StyledPlusIcon } from "./styles";
import { FoundItemCardType } from "../../../../types/FoundItemTypes";

const Step1: React.FC<{
    loading: boolean;
    carouselSettings: any;
    preMatchedFoundItems: any[];
    handleItemClick: (item: any) => void;
    selectedItem: any;
    columns: any[];
    tableData: any[];
    isFinalMatch?: boolean;
    isModal?: boolean;
}> = ({ loading, carouselSettings, preMatchedFoundItems, handleItemClick, selectedItem, columns, tableData, isFinalMatch, isModal }) => {
    const expandIcon = ({ isActive }: { isActive?: boolean }) => {
        return isActive ? <StyledMinusIcon /> : <StyledPlusIcon />;
    };
    return (
        <Spin spinning={loading}>
            {!isFinalMatch && (
                <CarouselMainContainer>
                    <StyledCarousel {...carouselSettings} draggable arrows infinite={false}>
                        {preMatchedFoundItems &&
                            preMatchedFoundItems?.length > 0 &&
                            preMatchedFoundItems?.map((item, index) => (
                                <div key={index}>
                                    <PreMatchFoundItemCard handleItemClick={() => handleItemClick(item)} isModal={isModal} selectedItem={selectedItem} item={item} cardType={FoundItemCardType.Found_Item_PreMatch} status={item?.status} />
                                </div>
                            ))}
                    </StyledCarousel>
                </CarouselMainContainer>
            )}
            {isFinalMatch ? (
                <StyledCollapse expandIcon={expandIcon} defaultActiveKey={['1']}>
                    <StyledPanel header="Comparison" key="1">
                        <PreMatchStyledTable columns={columns} dataSource={tableData} pagination={false} rowClassName={(record, index) => (index % 2 === 0 ? "even-row" : "odd-row")} />
                    </StyledPanel>
                </StyledCollapse>
            ) : (
                <StyledTableWrapper>
                    <PreMatchStyledTable columns={columns} dataSource={tableData} pagination={false} rowClassName={(record, index) => (index % 2 === 0 ? "even-row" : "odd-row")} />
                </StyledTableWrapper>
            )}
        </Spin>
    );
};

export default Step1;
